// Gentle haptics for Android and other devices with a vibration motor.
// Off by default in no-motor browsers, and always respectful of the
// "reduce motion" preference — a quiet buzz is still motion to some people.
import { getOption, setOption } from "./persistOptions";

export type Buzz = "tap" | "confirm" | "warn" | "error";

const KEY = "haptics:on";

// Short, soft pulses — long rattling patterns sound harsh through the phone body.
const PATTERNS: Record<Buzz, number | number[]> = {
  tap: 8,
  confirm: [10, 50, 10],
  warn: 25,
  error: [35, 70, 35],
};

export function hapticsSupported(): boolean {
  return typeof navigator !== "undefined" && typeof navigator.vibrate === "function";
}

export function hapticsOn(): boolean {
  return getOption<boolean>(KEY, true) && hapticsSupported();
}

export function setHaptics(on: boolean) {
  setOption(KEY, on);
}

function reduceMotion(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;
}

let lastBuzz = 0;
export function buzz(kind: Buzz = "tap") {
  if (!hapticsOn() || reduceMotion()) return;
  const now = Date.now();
  // Rapid taps stacking into one long grind is what sounds "diabolical".
  if (now - lastBuzz < 150) return;
  lastBuzz = now;
  try { navigator.vibrate(PATTERNS[kind]); } catch { /* motor busy or blocked */ }
}
